import { message as messageAD } from "antd";

messageAD.config({
  top: 40,
});

export const message = messageAD;
